"use client";

import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Doğal diş görünümü ve kusursuz ışık geçirgenliği", "Biyouyumlu materyal ile sağlıklı diş eti uyumu", "Yüksek dayanıklılık ve uzun ömürlü kullanım", "Sıcak ve soğuğa karşı minimize edilmiş hassasiyet"];
export default function TreatmentDetails() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: false
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="treatment-details" className="bg-secondary py-40 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-serif text-[48px] leading-tight text-foreground mb-8">
              Gülüşünüzün Doğal Gücü
            </h2>
            
            <p className="font-sans text-[16px] leading-[1.6] text-foreground/80 mb-10">
              Zirkonyum kaplamalar, doğal diş minesine en yakın ışık geçirgenliğine sahip, 
              estetik diş hekimliğinin sunduğu en yenilikçi materyallerden biridir. 
              Estetik zarafeti ve mekanik dayanıklılığı mükemmel bir dengede sunarak, 
              size yıllarca sürecek sağlıklı, doğal ve ışıltılı bir gülüş armağan eder.
            </p>

            <ul className="space-y-5 mb-12">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start">
                  <span className="flex-shrink-0 mt-1 mr-4">
                    <Check className="w-5 h-5 text-primary stroke-[1px]" />
                  </span>
                  <span className="font-sans text-[16px] leading-[1.6] text-foreground/80">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div>
              
            </div>
          </div>

          {}
          <div className="lg:col-span-7 relative">
            <div className="relative max-w-lg mx-auto lg:max-w-none lg:ml-auto lg:mr-0 pl-0 lg:pl-[80px] pt-0 lg:pt-[80px]">
              
              {}
              <div className="absolute top-0 left-0 w-[calc(100%-80px)] h-[calc(100%-80px)] border-[0.5px] border-primary hidden lg:block z-0" />
              
              {}
              <div ref={imageRef} className={`relative z-10 w-full transition-transform duration-1000 ease-out will-change-transform ${isImageVisible ? "translate-y-0" : "translate-y-16"}`}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/zirconium_material_translucent_detail.png" alt="Zirkonyum materyalinin ışık geçirgenliği ve doğal yapısı" className="w-full h-auto object-cover aspect-[3/4] shadow-2xl shadow-primary/5" loading="lazy" />
              </div>
              
            </div>
          </div>

        </div>
      </div>
    </section>;
}